import React from "react";
import { useQuery } from "react-query";
import BajajBike from "./BajajBike";

const Bajaj = () => {
  const { isLoading, data: bikes } = useQuery({
    queryKey: ["Bikes Suzuki"],
    queryFn: () =>
      fetch(
        "https://bike-resell-server-hasanalibd.vercel.app/bikes/Bajaj"
      ).then((res) => res.json()),
  });
  console.log(bikes);

  return (
    <div>
      {bikes?.map((bike) => (
        <BajajBike key={bike._id} bike={bike}></BajajBike>
      ))}
    </div>
  );
};

export default Bajaj;
